import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'image'
})
export class ImagePipe implements PipeTransform {

  transform(image: any, type: string = 'item'): any {

    if (!image || image === '') {
      return '../../../assets/images/default-thumbnail.jpg';
    }

    return image;
  }

}
